// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__MQyLp {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
}

.styles_background__iL\\+YN {
  background-color: #0f2047;
  border-radius: 20px;
  box-shadow: 2px 2px 5px black;
  padding: 5%;
}

.styles_titulo404__9iped {
  color: #ffffff;
    font-weight: bold;
    font-size: 3rem;
}

.styles_titulo__5Xgi6 {
  color: #ffffff;
  font-weight: bold;
  font-size: 2rem;
  text-align: center;
}

.styles_logoMenu__bpGko {
  width: 12rem !important;
  height: auto !important;
}

@media screen and (max-width: 426px) {
  .styles_titulo404__9iped{
    font-size: 2.5rem;
  }

  .styles_titulo__5Xgi6 {
    font-size: 1.5rem;
  }

  .styles_logoMenu__bpGko {
    width: 10rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/NotFound/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n}\n\n.background {\n  background-color: #0f2047;\n  border-radius: 20px;\n  box-shadow: 2px 2px 5px black;\n  padding: 5%;\n}\n\n.titulo404 {\n  color: #ffffff;\n    font-weight: bold;\n    font-size: 3rem;\n}\n\n.titulo {\n  color: #ffffff;\n  font-weight: bold;\n  font-size: 2rem;\n  text-align: center;\n}\n\n.logoMenu {\n  width: 12rem !important;\n  height: auto !important;\n}\n\n@media screen and (max-width: 426px) {\n  .titulo404{\n    font-size: 2.5rem;\n  }\n\n  .titulo {\n    font-size: 1.5rem;\n  }\n\n  .logoMenu {\n    width: 10rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__MQyLp`,
	"background": `styles_background__iL+YN`,
	"titulo404": `styles_titulo404__9iped`,
	"titulo": `styles_titulo__5Xgi6`,
	"logoMenu": `styles_logoMenu__bpGko`
};
export default ___CSS_LOADER_EXPORT___;
